import AuthenticationCard from "../Components/AuthenticationCard";

import AuthenticationLayout from "../../../layouts/authentication/AuthenticationLayout";

const SigninPage = () => {
    return ( 
      
        <AuthenticationLayout >
        <AuthenticationCard />
        </AuthenticationLayout>
       
     );
}
 
export default SigninPage;